import { PATHS } from "../layout/path/Path";

export const routerHiddenMenu = [PATHS.LOGIN];

export const TYPE_SHOW_NOTI = {
  err: "error",
  success: "success",
};

export const menuParent = {
  bitel: "bitel",
  halotel: "halotel",
  campuchia: "campuchia",
  mytel: "mytel",
  movitel: "movitel",
  unitel: "unitel",
  natcom: "natcom",
  config: "config",
  natcom_vmail: "natcom_vmail",
  vietnam: "bicagame"
};

export const menuLink = [
  {
    title: menuParent.bitel,
    children: [PATHS.BITEL_SUBASTA, PATHS.BITEL_AIRTIME, PATHS.BITEL_REVENUE],
  },
  {
    title: menuParent.halotel,
    children: [PATHS.HALOTEL_AIRTIME, PATHS.HALOTEL_HALOGAME],
  },
  {
    title: menuParent.vietnam,
    children: [PATHS.BICAGAME, PATHS.BICAGAME],
  },
  {
    title: menuParent.mytel,
    children: [PATHS.MYTEL_VOICEMESSAGE, PATHS.MYTEL_AUCTION],
  },
  {
    title: menuParent.movitel,
    children: [PATHS.MOVITEL_MAGIC_WHEEL],
  },
  { title: menuParent.unitel, children: [PATHS.UNITEL_REVENUE] },
  {
    title: menuParent.natcom,
    children: [PATHS.VMAIL_NTM_AIRTIME, PATHS.NATCOM_AIRTIME, PATHS.NATCOM_NTM],
  },
  {
    title: menuParent.config,
    children: [PATHS.CONFIG_ALERT],
  },
];

export const columnsBitelRevenue = {
  dataKey: [
    {
      title: "Package",
      dataIndex: "Package",
      key: "Package",
      width: 100,
      fixed: "left",
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
      width: 100,
      fixed: "left",
    },
    {
      title: "Revenue (Sol)",
      children: [
        {
          title: "SMS",
          dataIndex: "SMS",
          key: "SMS",
          width: "auto",
          //   sorter: (a, b) => a.age - b.age,
        },
        {
          title: "USSD",
          dataIndex: "USSD",
          key: "USSD",
          width: "auto",
        },
        {
          title: "Mibitel",
          dataIndex: "Mibitel",
          key: "Mibitel",
          width: "auto",
          fixed: "right",
        },

        {
          title: "Web/Wap",
          dataIndex: "Web_Wap",
          key: "Web_Wap",
          width: "auto",
          fixed: "right",
        },
        {
          title: "Total Revenue",
          dataIndex: "TotalRevenue",
          key: "TotalRevenue",
          width: "auto",
          fixed: "right",
        },
      ],
    },
  ],

  defineData: [
    {
      key: "day",
      Package: "Day",
      name: "Day",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
    {
      key: "week",
      Package: "Week",
      name: "Week",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
    {
      key: "month",
      Package: "Month",
      name: "Month",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
    {
      key: "chance",
      Package: "Chance",
      name: "Chance",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
    {
      key: "chance2",
      Package: "Chance2",
      name: "Chance2",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
    {
      key: "chance5",
      Package: "Chance5",
      name: "Chance5",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
    {
      key: "chance10",
      Package: "Chance10",
      name: "Chance10",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
    {
      key: "total",
      Package: "Total",
      name: "Total",
      Quantity: 0,
      SMS: 0,
      USSD: 0,
      Mibitel: 0,
      Web_Wap: 0,
      TotalRevenue: 0,
    },
  ],
};

export const columnsHalotelRevenue = {
  dataKey: [
    {
      title: "Time",
      dataIndex: "Time",
      key: "Time",
      width: 200,
      fixed: "left",
    },
    {
      title: "Total Revenue",
      dataIndex: "totalRevenue",
      key: "totalRevenue",
      width: 100,
      // fixed: "left",
    },
    {
      title: "Registration Revenue",
      children: [
        {
          title: "Daily",
          dataIndex: "registrationDaily",
          key: "registrationDaily",
          width: "auto",
          //   sorter: (a, b) => a.age - b.age,
        },
        {
          title: "Weekly",
          dataIndex: "weeklyRegistration",
          key: "weeklyRegistration",
          width: "auto",
        },
        {
          title: "Monthly",
          dataIndex: "MonthlyRegistration",
          key: "MonthlyRegistration",
          width: "auto",
          // fixed: "right",
        },
      ],
    },
    {
      title: "Extend Revenue",
      children: [
        {
          title: "Daily",
          dataIndex: "DailyExtend",
          key: "DailyExtend",
          width: "auto",
          //   sorter: (a, b) => a.age - b.age,
        },
        {
          title: "Weekly",
          dataIndex: "WeeklyExtend",
          key: "WeeklyExtend",
          width: "auto",
        },
        {
          title: "Monthly",
          dataIndex: "MonthlyExtend",
          key: "MonthlyExtend",
          width: "auto",
          // fixed: "right",
        },
      ],
    },
  ],
  defineData: [],
};

export const TYPE_GET_DATE = {
  now: 0,
  oneMonthAgo: 1,
  oneDayAgo: 2,
};

export const TYPE_CHECK_DASHBOARD = {
  overview: 1,
  revenue: 2,
};

export const tableBetelDailyRevenue = {
  dataKey: [
    {
      title: "Charge time",
      dataIndex: "Chargetime",
      key: "Chargetime",
      fixed: "left",
    },
    {
      title: "Day",
      dataIndex: "Day",
      key: "Day",
      id: "SUBASTA_DAILY",
    },
    {
      title: "Week",
      dataIndex: "Week",
      key: "Week",
      id: "SUBASTA_WEEKLY",
    },
    {
      title: "Month",
      dataIndex: "Month",
      key: "Month",
      id: "SUBASTA_MONTHLY",
    },
    {
      title: "CHANCE",
      dataIndex: "CHANCE",
      key: "CHANCE",
      id: "CHANCE",
    },
    {
      title: "CHANCE2",
      dataIndex: "CHANCE2",
      key: "CHANCE2",
      id: "CHANCE2",
    },
    {
      title: "CHANCE5",
      dataIndex: "CHANCE5",
      key: "CHANCE5",
      id: "CHANCE5",
    },
    {
      title: "CHANCE10",
      dataIndex: "CHANCE10",
      key: "CHANCE10",
      id: "CHANCE10",
    },
    {
      title: "Register Revenue",
      dataIndex: "TotalRegRevenue",
      key: "TotalRegRevenue",
      id: "TotalRegRevenue",
    },
    {
      title: "Renew Revenue",
      dataIndex: "TotalRenewRevenue",
      key: "TotalRenewRevenue",
      id: "TotalRenewRevenue",
    },
    {
      title: "Retail Revenue",
      dataIndex: "TotalRetailRevenue",
      key: "TotalRetailRevenue",
      id: "TotalRetailRevenue",
    },
    {
      title: "Total Revenue",
      dataIndex: "Dayrevenue",
      key: "Dayrevenue",
      id: "Dayrevenue",
    },
  ],
  defineData: [],
};

export const DailyRevenueChart = {
  defineData: [],
  xField: "chargeTime",
  yField: "value",
};

export const DailyChartHalotel = {
  revenue: 1,
  quantity: 2,
  channel: 3,
};

export const tableMytelErrorCode = {
  dataKey: [
    {
      title:"Report date",
      dataIndex: "report_date",
      key: "report_date",
      fixed: "left"
    },
    {
      title:"Error code",
      dataIndex: "error_code",
      key: "error_code",
      fixed: "left"
    },
    {
      title:"Number error code",
      dataIndex: "num",
      key: "num",
      fixed: "left"
    },
  ]
}

export const tableMytelDailyRevenue = {
  dataKey: [
    {
      title: "Charge time",
      dataIndex: "Chargetime",
      key: "Chargetime",
      fixed: "left",
    },
    {
      title: "Day",
      dataIndex: "Day",
      key: "Day",
      // fixed: "left",
    },
    {
      title: "Week",
      dataIndex: "Week",
      key: "Week",
      // fixed: "left",
    },
    {
      title: "Month",
      dataIndex: "Month",
      key: "Month",
      // fixed: "left",
    },
    {
      title: "BID",
      dataIndex: "BID",
      key: "BID1",
      // fixed: "left",
    },
    {
      title: "BID2",
      dataIndex: "BID2",
      key: "BID2",
      // fixed: "left",
    },
    {
      title: "BID5",
      dataIndex: "BID5",
      key: "BID5",
      // fixed: "left",
    },
    {
      title: "BID10",
      dataIndex: "BID10",
      key: "BID10",
      // fixed: "center",
    },
    {
      title: "BID20",
      dataIndex: "BID20",
      key: "BID20",
      // fixed: "center",
    },
    {
      title: "Register Revenue",
      dataIndex: "TotalRegRevenue",
      key: "TotalRegRevenue",
      id: "TotalRegRevenue",
    },
    {
      title: "Renew Revenue",
      dataIndex: "TotalRenewRevenue",
      key: "TotalRenewRevenue",
      id: "TotalRenewRevenue",
    },
    {
      title: "Retail Revenue",
      dataIndex: "TotalRetailRevenue",
      key: "TotalRetailRevenue",
      id: "TotalRetailRevenue",
    },
    {
      title: "Total Revenue",
      dataIndex: "Dayrevenue",
      key: "Dayrevenue",
      id: "Dayrevenue",
    },    
  ],
  defineData: [],
};
export const tableMagicWheelDailyRevenue = {
  dataKey: [
    {
      title: "Charge time",
      dataIndex: "Chargetime",
      key: "Chargetime",
      fixed: "left",
    },
    {
      title: "Day",
      dataIndex: "Day",
      key: "Day",
      // fixed: "left",
    },
    {
      title: "Week",
      dataIndex: "Week",
      key: "Week",
      // fixed: "left",
    },
    {
      title: "Month",
      dataIndex: "Month",
      key: "Month",
      // fixed: "left",
    },
    {
      title: "BUY3",
      dataIndex: "BUY3",
      key: "BUY3",
      // fixed: "left",
    },
    {
      title: "BUY5",
      dataIndex: "BUY5",
      key: "BUY5",
      // fixed: "left",
    },
    {
      title: "BUY10",
      dataIndex: "BUY10",
      key: "BUY10",
      // fixed: "center",
    },
    {
      title: "BUY50",
      dataIndex: "BUY50",
      key: "BUY50",
      // fixed: "center",
    },
    {
      title: "Register Revenue",
      dataIndex: "RegisterRevenue",
      key: "RegisterRevenue",
      width: 150,
      // fixed: "center",
    },
    {
      title: "Renew Revenue",
      dataIndex: "RenewRevenue",
      key: "RenewRevenue",
      width: 150,
      // fixed: "center",
    },
    {
      title: "Retail Revenue",
      dataIndex: "RetailRevenue",
      key: "RetailRevenue",
      width: 150,
      // fixed: "center",
    },
    {
      title: "Total Revenue",
      dataIndex: "TotalRevenue",
      key: "TotalRevenue",
      width: 150,
      // fixed: "center",
    },
  ],
  defineData: [],
};
export const tableMathMatchDailyRevenue = {
  dataKey: [
    {
      title: "Charge Time",
      dataIndex: "Chargetime",
      key: "Chargetime",
      fixed: "left",
    },
    {
      title: "Daily",
      dataIndex: "Day",
      key: "Day",
    },
    {
      title: "Weekly",
      dataIndex: "Week",
      key: "Week",
    },
    {
      title: "Monthly",
      dataIndex: "Month",
      key: "Month",
    },
    {
      title: "Tickets3",
      dataIndex: "BUY1",
      key: "BUY1",
    },
    {
      title: "Tickets10",
      dataIndex: "BUY2",
      key: "BUY2",
    },
    {
      title: "Tickets50",
      dataIndex: "BUY3",
      key: "BUY3",
    },
    {
      title: "Hint",
      dataIndex: "BUY4",
      key: "BUY4",
    },
    {
      title: "Swap",
      dataIndex: "BUY5",
      key: "BUY5",
    },
    {
      title: "Bomb",
      dataIndex: "BUY6",
      key: "BUY6",
    },
    {
      title: "Undo",
      dataIndex: "BUY7",
      key: "BUY7",
    },
    {
      title: "Radar",
      dataIndex: "BUY8",
      key: "BUY8",
    },
    {
      title: "Revive",
      dataIndex: "BUY9",
      key: "BUY9",
    },
    {
      title: "Guide",
      dataIndex: "BUY10",
      key: "BUY10",
    },
    {
      title: "Register Revenue",
      dataIndex: "RegisterRevenue",
      key: "RegisterRevenue",
      width: 150,
    },
    {
      title: "Renew Revenue",
      dataIndex: "RenewRevenue",
      key: "RenewRevenue",
      width: 150,
    },
    {
      title: "Retail Revenue",
      dataIndex: "RetailRevenue",
      key: "RetailRevenue",
      width: 150,
    },
    {
      title: "Total Revenue",
      dataIndex: "TotalRevenue",
      key: "TotalRevenue",
      width: 150,
    },
  ],
  defineData: [],
};

export const tabelMovitelDailyRevenue = {
  dataKey: [
    {
      title: "Charge time",
      dataIndex: "Chargetime",
      key: "Chargetime",
      fixed: "left",
    },
    {
      title: "Day",
      dataIndex: "Day",
      key: "Day",
      // fixed: "left",
      children: [
        {
          title: "Total",
          key: "DayTotal",
          render: (value, record) => {
            let total = 0;
            if (typeof record.Day === "object" && record.Day !== null) {
              total = record.Day.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "DayRevenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.Day === "object" && record.Day !== null) {
              revenue = record.Day.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "Week",
      dataIndex: "Week",
      key: "Week",
      // fixed: "left",
      children: [
        {
          title: "Total",
          key: "WeekTotal",
          render: (value, record) => {
            let total = 0;
            if (typeof record.Week === "object" && record.Week !== null) {
              total = record.Week.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "WeekRevenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.Week === "object" && record.Week !== null) {
              revenue = record.Week.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "Month",
      dataIndex: "Month",
      key: "Month",
      // fixed: "left",
      children: [
        {
          title: "Total",
          key: "MonthTotal",
          render: (value, record) => {
            let total = 0;
            if (typeof record.Month === "object" && record.Month !== null) {
              total = record.Month.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "MonthRevenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.Month === "object" && record.Month !== null) {
              revenue = record.Month.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "MR_DAY",
      dataIndex: "MrDay",
      key: "MrDay",
      children: [
        {
          title: "Total",
          key: "MrDayTotal",
          render: (value, record) => {
            let total = 0;
            if (typeof record.MrDay === "object" && record.MrDay !== null) {
              total = record.MrDay.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "MrDayRevenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.MrDay === "object" && record.MrDay !== null) {
              revenue = record.MrDay.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "MR_WEEK",
      dataIndex: "MrWeek",
      key: "MrWeek",
      children: [
        {
          title: "Total",
          key: "MrWeekTotal",
          render: (value, record) => {
            let total = 0;
            if (typeof record.MrWeek === "object" && record.MrWeek !== null) {
              total = record.MrWeek.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "MrWeekRevenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.MrWeek === "object" && record.MrWeek !== null) {
              revenue = record.MrWeek.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "MR_MON",
      dataIndex: "MrMon",
      key: "MrMon",
      children: [
        {
          title: "Total",
          key: "MrMonTotal",
          render: (value, record) => {
            let total = 0;
            if (typeof record.MrMon === "object" && record.MrMon !== null) {
              total = record.MrMon.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "MrMonRevenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.MrMon === "object" && record.MrMon !== null) {
              revenue = record.MrMon.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "MINUS2",
      dataIndex: "Minus2",
      key: "Minus2",
      children: [
        {
          title: "Total",
          key: "Minus2Total",
          render: (value, record) => {
            let total = 0;
            if (typeof record.Minus2 === "object" && record.Minus2 !== null) {
              total = record.Minus2.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "Minus2Revenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.Minus2 === "object" && record.Minus2 !== null) {
              revenue = record.Minus2.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "MINUS3",
      dataIndex: "Minus3",
      key: "Minus3",
      children: [
        {
          title: "Total",
          key: "Minus3Total",
          render: (value, record) => {
            let total = 0;
            if (typeof record.Minus3 === "object" && record.Minus3 !== null) {
              total = record.Minus3.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "Minus3Revenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.Minus3 === "object" && record.Minus3 !== null) {
              revenue = record.Minus3.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "MINUS4",
      dataIndex: "Minus4",
      key: "Minus4",
      children: [
        {
          title: "Total",
          key: "Minus4Total",
          render: (value, record) => {
            let total = 0;
            if (typeof record.Minus4 === "object" && record.Minus4 !== null) {
              total = record.Minus4.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "Minus4Revenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.Minus4 === "object" && record.Minus4 !== null) {
              revenue = record.Minus4.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    {
      title: "MINUS15",
      dataIndex: "Minus15",
      key: "Minus15",
      children: [
        {
          title: "Total",
          key: "Minus15Total",
          render: (value, record) => {
            let total = 0;
            if (typeof record.Minus15 === "object" && record.Minus15 !== null) {
              total = record.Minus15.total || 0;
            }
            return total;
          }
        },
        {
          title: "Revenue",
          key: "Minus15Revenue",
          render: (value, record) => {
            let revenue = 0;
            if (typeof record.Minus15 === "object" && record.Minus15 !== null) {
              revenue = record.Minus15.revenue || 0;
            }
            return revenue;
          }
        }
      ]
    },
    // {
    //   title: "Total Reg With Fee",
    //   dataIndex: "TotalRegisterWithFee",
    //   key: "TotalRegisterWithFee",
    // },    
    {
      title: "Register",
      // dataIndex: "TotalRegister",
      key: "Register",
      children: [
        {
          title: "Total",
          dataIndex: "TotalRegister",
          key: "TotalRegister",
        },  
        {
          title: "Revenue",
          dataIndex: "RegisterRevenue",
          // dataIndex: "TotalRegister",
          key: "TotalRegister",
        }
      ]
    },    
    {
      title: "Renew",
      // dataIndex: "TotalRenew",
      key: "Renew",
      children: [
        {
          title: "Total",
          dataIndex: "TotalRenew",
          key: "TotalRenew",
        },  
        {
          title: "Revenue",
          dataIndex: "RenewRevenue",
          key: "RenewRevenue",
        }
      ]
    },
    {
      title: "Total Cancel",
      dataIndex: "TotalCancel",
      key: "TotalCancel",
    },    
     {
      title: "Retail Revenue",
      dataIndex: "RetailRevenue",
      key: "RetailRevenue",
      width: 150,
      // fixed: "center",
    },
    // {
    //   title: "Register Revenue",
    //   dataIndex: "RegisterRevenue",
    //   key: "RegisterRevenue",
    //   width: 150,
    //   // fixed: "center",
    // },
    // {
    //   title: "Renew Revenue",
    //   dataIndex: "RenewRevenue",
    //   key: "RenewRevenue",
    //   width: 150,
    //   // fixed: "center",
    // },
    
    {
      title: "Total Revenue",
      dataIndex: "TotalRevenue",
      key: "TotalRevenue",
      width: 150,
      // fixed: "center",
    },
  ],
  defineData: [],
};

export const keyDataExcel = [
  "charge_time",
  "day_register",
  "week_register",
  "month_register",
  "day_extend",
  "week_extend",
  "month_extend",
  "sms",
  "web_wap",
  "quantity_daily",
  "quantity_week",
  "quantity_month",
];

export const keyDataExcelAirtimeBitel = [
  "fecha",
  "total_loaned",
  "added_fee",
  "total_recovered",
  "fee_recovered",
];
export const idProject = {
  bitel: 1,
  mytel: 2,
  halotel: 3,
  unitel: 4,
  airtime: 5,
};

export const accessDataExcel = {
  pending: 0,
  isSuccess: 1,
  isFalse: 2,
};

export const defineColumnsStaticTableUnitel = [
  {
    title: "Package",
    dataIndex: "package",
    key: "package",
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    title: "Total Revenue(Kip)",
    dataIndex: "totalRevenue",
    key: "totalRevenue",
  },
];

export const defineColumnsDetailTableUnitel = [
  {
    title: "Report Date",
    dataIndex: "time",
    key: "time",
    width: 50,
  },
  {
    title: "Total Register",
    dataIndex: "charge_register",
    key: "charge_register",
    width: 50,
    fixed: "left",
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Cancel",
    dataIndex: "total_cancel",
    key: "total_cancel",
    width: 50,
    fixed: "left",
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Renew",
    dataIndex: "charge_renew",
    key: "charge_renew",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Charge",
    dataIndex: "charge_total",
    key: "charge_total",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Register Revenue",
    dataIndex: "revenue_register",
    key: "revenue_register",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Renew Revenue",
    dataIndex: "revenue_renew",
    key: "revenue_renew",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Revenue",
    dataIndex: "revenue_total",
    key: "revenue_total",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
];

export const defineColumnsDetailTableBicagame = [
  {
    title: "Report Date",
    dataIndex: "report_date",
    key: "report_date",
    width: 50,
  },
  {
    title: "Total Register",
    dataIndex: "register_success",
    key: "register_success",
    width: 50,
    fixed: "left",
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Renew",
    dataIndex: "renew_success",
    key: "renew_success",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Cancel",
    dataIndex: "total_cancel",
    key: "total_cancel",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Register Revenue",
    dataIndex: "register_revenue",
    key: "register_revenue",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Renew Revenue",
    dataIndex: "renew_revenue",
    key: "renew_revenue",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Revenue",
    dataIndex: "total_revenue",
    key: "total_revenue",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
];

export const defineColumnsDetailTableHaloGame = [
  {
    title: "Report Date",
    dataIndex: "report_date",
    key: "report_date",
    width: 50,
  },
  {
    title: "Total Register",
    dataIndex: "total_register",
    key: "total_register",
    width: 50,
    fixed: "left",
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Renew",
    dataIndex: "total_renew",
    key: "total_renew",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Cancel",
    dataIndex: "total_cancel",
    key: "total_cancel",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Register Revenue",
    dataIndex: "total_revenue_register",
    key: "total_revenue_register",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Renew Revenue",
    dataIndex: "total_revenue_renew",
    key: "total_revenue_renew",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
  {
    title: "Total Revenue",
    dataIndex: "total_revenue",
    key: "total_revenue",
    width: 50,
    render: (value) => value != null ? Number(value).toLocaleString("en-US") : 0,
  },
];



export const columnsAirtimeRevenue = {
  dataKey: [
    {
      title: "Fetcha",
      dataIndex: "fecha",
      key: "fecha",
      width: 100,
      fixed: "left",
    },
    {
      title: "Total loaned",
      dataIndex: "totalLoaned",
      key: "totalLoaned",
      width: 100,
    },
    {
      title: "Added fee",
      dataIndex: "addedFee",
      key: "addedFee",
      width: 100,
    },
    {
      title: "Total Recovered",
      dataIndex: "totalRecovered",
      key: "totalRecovered",
      width: 100,
    },
    {
      title: "Fee Recovered",
      dataIndex: "feeRecovered",
      key: "feeRecovered",
      width: 100,
    },
  ],
  defineData: [],
};
